import { createAction } from 'redux-actions';
import { http } from 'helpers/axios';
import { store } from 'store/createStore';

export const createPassInfo = createAction(
  '@@passinfo/createPassInfo',
  passInfo => () => {
    return http
      .post(`/createPassInfo`, {
        token: passInfo.token,
        template: passInfo.template,
        subject: passInfo.subject,
        message: passInfo.message,
        group: store.getState().auth.currentGroup._id,
      })
      .then(({ data }) => {
        return data;
      });
  }
);

export const fetchPassInfoList = createAction(
  '@@passinfo/fetchPassInfoList',
  () => () => {
    return http
      .post(`/listpassinfo`, {
        group: store.getState().auth.currentGroup._id,
      })
      .then(({ data }) => {
        return data;
      });
  }
);

export const changePassInfo = createAction(
  '@@passinfo/changePassInfo',
  passInfo => () => {
    passInfo.group = store.getState().auth.currentGroup._id;
    return http
      .put(`/passkitinfo/update`, {
        query: passInfo,
      })
      .then(({ data }) => {
        return data;
      });
  }
);
